import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiStar, FiShoppingCart, FiHeart, FiEye } from 'react-icons/fi';
import { useCart } from '../context/CartContext';
import { useToast } from '../context/ToastContext';

const ProductCard = ({ product }) => {
  const [wishlist, setWishlist] = useState(false);
  const { dispatch } = useCart();
  const { addToast } = useToast();

  const handleAddToCart = (e) => {
    e.preventDefault();
    dispatch({ type: 'ADD_TO_CART', payload: product });
    dispatch({ type: 'OPEN_DRAWER' });
    addToast(`${product.name} added to cart! 🛍️`);
  };

  const handleWishlist = (e) => {
    e.preventDefault();
    setWishlist(!wishlist);
    addToast(wishlist ? 'Removed from wishlist' : `${product.name} added to wishlist ❤️`);
  };

  const discount = Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100);

  return (
    <motion.div
      className="product-card"
      whileHover={{ y: -8 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
    >
      <Link to={`/product/${product.id}`} className="product-card-link">
        {/* Image */}
        <div className="product-card-img-wrapper">
          <img
            src={product.image}
            alt={product.name}
            className="product-card-img"
            loading="lazy"
          />
          {/* Badge */}
          {product.badge && (
            <span className={`product-badge badge-${product.badge.toLowerCase().replace(' ', '-')}`}>
              {product.badge}
            </span>
          )}
          {/* Discount */}
          {discount > 0 && (
            <span className="product-discount">-{discount}%</span>
          )}
          {/* Hover Actions */}
          <div className="product-actions">
            <motion.button
              className={`action-btn ${wishlist ? 'active' : ''}`}
              onClick={handleWishlist}
              whileTap={{ scale: 0.9 }}
              aria-label="Wishlist"
            >
              <FiHeart size={18} fill={wishlist ? 'currentColor' : 'none'} />
            </motion.button>
            <motion.button
              className="action-btn"
              whileTap={{ scale: 0.9 }}
              aria-label="Quick view"
            >
              <FiEye size={18} />
            </motion.button>
          </div>
        </div>

        {/* Info */}
        <div className="product-card-info">
          <span className="product-category">{product.category}</span>
          <h3 className="product-name">{product.name}</h3>

          {/* Rating */}
          <div className="product-rating">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <FiStar
                  key={i}
                  size={12}
                  fill={i < Math.floor(product.rating) ? '#F59E0B' : 'none'}
                  stroke={i < Math.floor(product.rating) ? '#F59E0B' : '#666'}
                />
              ))}
            </div>
            <span className="rating-text">{product.rating} ({product.reviews.toLocaleString()})</span>
          </div>

          {/* Price */}
          <div className="product-price-row">
            <span className="product-price">¥{product.price}</span>
            {product.originalPrice > product.price && (
              <span className="product-original-price">¥{product.originalPrice}</span>
            )}
          </div>

          {/* Add to Cart */}
          <motion.button
            className="btn btn-primary btn-full add-to-cart-btn"
            onClick={handleAddToCart}
            whileTap={{ scale: 0.97 }}
          >
            <FiShoppingCart size={16} />
            Add to Cart
          </motion.button>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
